import { Component, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-rechute',
  templateUrl: './rechute.component.html',
  styleUrls: ['./rechute.component.scss']
})
export class RechuteComponent implements OnInit {

  constructor(public generalService: GeneralService) { }
  id=null
  ngOnInit(): void {
  }
  search()
  {
    this.generalService.getDS('avtPerso', this.id).subscribe(res => {
      console.log(res);
  })
}

}
